import normalizeImageSrc from '../normalizeImageSrc';

const updateProductGallery = (container, variant) => {
  const gallery = container?.querySelector('[data-gallery-update-swiper-on-change]');
  if (!gallery) return;

  const firstImageContainers = gallery.querySelectorAll('[data-first-image-container]');
  if (!firstImageContainers.length) return;
  if (!variant) return;

  const variantSrc = variant.featured_image?.src;
  const fallbackSrc = gallery.dataset.defaultImageSrc;
  const targetSrc = variantSrc ? normalizeImageSrc(variantSrc) : fallbackSrc;
  if (!targetSrc) return;

  const targetAlt = variant.featured_image?.alt || gallery.dataset.defaultImageAlt;

  firstImageContainers.forEach((container) => {
    const imageEl = container.querySelector('img');
    if (!imageEl) return;
    if (imageEl.getAttribute('src') === targetSrc) return;

    imageEl.setAttribute('src', targetSrc);
    if (imageEl.hasAttribute('srcset')) imageEl.setAttribute('srcset', targetSrc);
    if (targetAlt) imageEl.setAttribute('alt', targetAlt);
  });
};

export default updateProductGallery;
